import React from "react";
import { onFormClick } from "../../../utils/helper";
import Icon from "../../../dashboard/Icon/Icon";
import "./LaunchTile.css";
import analytics from "../../../utils/analytics";

const LaunchTile = ({ config }) => {
  const { displayName, icon, width, height } = config;
  const isSingleLine = height === 36;

  const onLaunchTileClick = () => {
    onFormClick(config);

    const analyticsData = {
      category: "widget_click",
      type: "click"
    };
    analytics.sendEvent(`iconlauncher tile clicked`, analyticsData);
  };

  return (
    <div
      className={`launch-tile overflow-ellipsis ${isSingleLine ? "inline" : "multi-line" }`}
      draggable="false"
      onClick={onLaunchTileClick}
      style={{ width, height }}
    >
      <div className="icon-wrapper">
        <Icon
          src={`images/${icon.imgName}.svg`}
          alt={displayName}
          className="icon icon-launcher"
          draggable="false"
          title={displayName}
        />
      </div>
      <span className="label ng_p_2_m overflow-ellipsis" title={displayName}>
        {displayName}
      </span>
    </div>
  );
};

export default LaunchTile;
